/** Mobile live map full-screen surface (grid table vs map). */
export enum LiveMapMobileSurfaceEnum {
  Grid = "Grid",
  Map = "Map",
}
